import PinCodeService from './pinCodeService'

export default PinCodeService
